<template>
  <div class="download-order" v-if="order">
    <a href="#" @click.prevent="downloadCSVOrder()" title="Download Order to Excel"><img src="@/assets/images/excel-download1x.png" alt="Download to Excel" /></a>
  </div>
</template>


<script>

  import XLSX from 'sheetjs-style';
  import moment from 'moment';
  import tpnMixin from '@/mixins/tpnMixin';

  export default {
  name: 'DownloadOrder',
  mixins: [tpnMixin],
  props: {
    order: {
      required: true,
    },
  },
  data() {
    return {
      Datas: {
        // We will make a Workbook contains 2 Worksheets
      },
    };
  },
  methods: {
    coalesce(...args) {
      for (let i = 0; i < arguments.length; i += 1) {
        if (args[i] != null) {
          return args[i] + '';
        }
      }
      return '';
    },
    roundNicely(num) {
      let retnum = Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;
      retnum = Number.isNaN(retnum) ? '' : retnum + '';
      return retnum;
    },
    downloadCSVOrder() {
      const isSubmittedOrder = this.order.orderReference;
      const orderRef = (this.order.orderReference ? this.order.orderReference : this.order.orderRefView);
      const isTPN = this.isTPN();
      const dataArray = [];
      dataArray.push(['Order Reference', orderRef]);
      dataArray.push(['Date Required', (this.order.date_required ? this.order.date_required : this.order.deliveryDate)]);
      if (!isTPN) {
        dataArray.push(['Patients', (this.order.patients_count ? this.order.patients_count : this.order.patientCount)]);
      }
      dataArray.push(['Items Ordered', (this.order.items_ordered_count ? this.order.items_ordered_count : this.order.drugCount)]);
      dataArray.push(['Comment', this.coalesce(this.order.comment)]);
      dataArray.push([]);
      dataArray.push([]);

      const headers = [];
      if (!isTPN) {
        headers.push('Patient First Name');
        headers.push('Patient Surname');
        headers.push('Patient MRN');
        headers.push('Date of Birth');
      }
      headers.push('Quantity');
      headers.push('Delivery Date');
      headers.push('Finished Product Code');
      headers.push('Drug 1 Name');
      headers.push('Drug 1 Dose');
      headers.push('Drug 1 UOM');
      headers.push('Drug 2 Name');
      headers.push('Drug 2 Dose');
      headers.push('Drug 2 UOM');
      headers.push('Route');
      headers.push('Container Type');
      headers.push('Container');
      headers.push('Diluent');
      headers.push('Volume (ml)');
      headers.push('Infusion Time (hrs)');
      headers.push('Ancillary 1');
      headers.push('Ancillary 2');
      headers.push('Treatment Date');
      headers.push('Order Status');
      headers.push('On Hold?');
//      headers.push('Missing Stability?');
//      headers.push('Above Guidance Dose?');

      const orderData = [];
      let patientDetails = false;
      let orderItems = false;
      let orderDetails = false;
      let patientsData = this.order.patients_data ? Object.entries(this.order.patients_data) : (this.order.patients);
      if (!Array.isArray(patientsData)) {
        patientsData = Object.entries(patientsData);
      }
      patientsData.forEach((patientRow) => {
        patientDetails = patientRow[1] ? patientRow[1].details : patientRow;
        orderItems = patientRow[1] ? Object.entries(patientRow[1].items) : patientRow.drugs;
        orderItems.forEach((orderRow) => {
          if (orderRow.drug1_name || orderRow.drug1GenericName || orderRow.tpn_product) {
            orderDetails = orderRow;
          } else {
            [, orderDetails] = orderRow;
          }

          let csvPatientFirstName = 'Unspecified';
          let csvPatientLastName = 'Unspecified';

          if (patientDetails.firstName) {
            csvPatientFirstName = patientDetails.firstName;
            csvPatientLastName = patientDetails.lastName;
          } else if (patientDetails.fullName) {
            csvPatientFirstName = (patientDetails.fullName).split(' ').slice(0, -1).join(' ');
            csvPatientLastName = (patientDetails.fullName).split(' ').slice(-1).join(' ');
          }

          const csvPatientMrn = this.coalesce(patientDetails.medicalReferenceNumber, patientDetails.medicalRecordNumber, 'Unspecified');
          const csvPatientDOB = this.coalesce(patientDetails.birthDateFormatted, patientDetails.dateOfBirth, 'Unspecified');
          const csvOrderFPCode = this.coalesce(orderDetails.finishedProductCode, orderDetails.tpn_code);
          let csvOrderDrug1Name = false;
          if (orderDetails.tpn_code) {
            csvOrderDrug1Name = orderDetails.tpn_product;
          } else if (orderDetails.finishedProductCode) {
              csvOrderDrug1Name = this.coalesce(orderDetails.drug1GenericName, orderDetails.drugName, orderDetails.description, orderDetails.drug1Name, orderDetails.drug1_name);
          } else {
            csvOrderDrug1Name = this.coalesce(orderDetails.drug1Name, orderDetails.drug1_name);
          }
          const csvOrderDrug1Dose = this.roundNicely(this.coalesce(orderDetails.drug1Dose));
          const csvOrderDrug1UOM = this.coalesce(orderDetails.drug1UOM, orderDetails.drug1_maxdose_uom);

          let csvOrderDrug2Name = false;
          if (orderDetails.finishedProductCode) {
            csvOrderDrug2Name = this.coalesce(orderDetails.drug2GenericName, orderDetails.drug2Name, orderDetails.drug2_name);
          } else {
            csvOrderDrug2Name = this.coalesce(orderDetails.drug2Name, orderDetails.drug2_name);
          }
          const csvOrderDrug2Dose = this.roundNicely(this.coalesce(orderDetails.drug2Dose));
          const csvOrderDrug2UOM = this.coalesce(orderDetails.drug2UOM, orderDetails.drug2_maxdose_uom);
          const csvOrderRoute = this.coalesce(orderDetails.administrationRouteDescription, orderDetails.admin_route_desc);
          const csvOrderContainerType = this.coalesce(orderDetails.container_type_name, orderDetails.containerTypeName, orderDetails.containerType, orderDetails.container, orderDetails.deviceGenericName);
          const csvOrderContainer = this.coalesce(orderDetails.container);

          const csvOrderDiluent = this.coalesce(orderDetails.diluent, orderDetails.diluentGenericName);

          let csvOrderVolume = '';
          if (((csvOrderContainerType === 'Infusor') || (csvOrderContainerType === 'Intermate')) && !isSubmittedOrder) {
            csvOrderVolume = '';
          } else {
            csvOrderVolume = this.roundNicely(this.coalesce(orderDetails.totalVolume, orderDetails.diluentVolume));
          }
          const csvOrderInfusionTime = this.roundNicely(this.coalesce(orderDetails.infusionTime));
          const csvOrderAncilliary1 = this.coalesce(orderDetails.ancillary1Name);
          const csvOrderAncilliary2 = this.coalesce(orderDetails.ancillary2Name);
          const csvOrderStatus = this.coalesce(orderDetails.status, this.order.draftSaved ? 'DRAFT' : 'New - Not submitted');
          const csvOrderonHold = (orderDetails.onHold && (orderDetails.onHold !== '0') ? 'YES' : 'NO');
         // const csvStabilityAlert = orderDetails.overrideStability ? 'YES' : '';
         // const csvDosageAlert = orderDetails.overrideDosage ? 'YES' : '';
          // const csvOrderFPStability = this.coalesce(orderDetails.stability);
          let deliveryDateArray;
          if (orderRow.deliveryDateArray) {
            deliveryDateArray = orderRow.deliveryDateArray;
          } else if (orderDetails.customerRequiredDate) {
            deliveryDateArray = [[moment(orderDetails.customerRequiredDate).format('DD/MM/YYYY'), orderDetails.administrationDate ? moment(orderDetails.administrationDate).format('DD/MM/YYYY') : '', orderDetails.quantity]];
          } else {
            deliveryDateArray = [[orderDetails.dateRequiredFormatted, orderDetails.administrationDate ? moment(orderDetails.administrationDate).format('DD/MM/YYYY') : '', orderDetails.quantity]];
          }

          deliveryDateArray.forEach((deliveryDates) => {
            const orderRowData = [];
            orderRowData.push();
            if (!isTPN) {
              orderRowData.push(csvPatientFirstName);
              orderRowData.push(csvPatientLastName);
              orderRowData.push(csvPatientMrn);
              orderRowData.push(csvPatientDOB !== 'false' ? csvPatientDOB : '');
            }
            orderRowData.push(deliveryDates[2]);
            orderRowData.push(deliveryDates[0]);
            orderRowData.push(csvOrderFPCode);
            orderRowData.push(csvOrderDrug1Name);
            orderRowData.push(csvOrderDrug1Dose);
            orderRowData.push(csvOrderDrug1UOM);
            orderRowData.push(csvOrderDrug2Name);
            orderRowData.push(csvOrderDrug2Dose);
            orderRowData.push(csvOrderDrug2UOM);
            orderRowData.push(csvOrderRoute);
            orderRowData.push(csvOrderContainerType);
            orderRowData.push(csvOrderContainer);
            orderRowData.push(csvOrderDiluent);
            orderRowData.push(csvOrderVolume);
            orderRowData.push(csvOrderInfusionTime);
            orderRowData.push(csvOrderAncilliary1);
            orderRowData.push(csvOrderAncilliary2);
            orderRowData.push(deliveryDates[1] ? deliveryDates[1] : '');
            orderRowData.push(csvOrderStatus);
            orderRowData.push(csvOrderonHold);
            //          orderRowData.push(csvStabilityAlert);
//          orderRowData.push(csvDosageAlert);

            orderData.push(orderRowData);
          });
        });
      });

      const headersFoundContent = [];
      let foundContent = false;
      let doWeNeedToRemoveACol = false;
      const wsWidths = [];
      headers.forEach((colHeader, colIndex) => {
        wsWidths.push({ wch: colHeader.length });

        foundContent = false;

        orderData.forEach((orderRow) => {
          if (orderRow[colIndex].length > 0) {
            foundContent = true;

            if (orderRow[colIndex].length > wsWidths[wsWidths.length - 1].wch) {
              wsWidths[wsWidths.length - 1].wch = orderRow[colIndex].length;
            }
          }
        });
        doWeNeedToRemoveACol = doWeNeedToRemoveACol || !foundContent; // if any col has no content
        headersFoundContent.push(foundContent);
        wsWidths[wsWidths.length - 1].wch = wsWidths[wsWidths.length - 1].wch + 2;
      });

      if (doWeNeedToRemoveACol) {
        Object.keys(headersFoundContent).reverse().forEach((col) => {
          const foundColContent = headersFoundContent[col];
          if (!foundColContent) {
            headers.splice(col, 1);
            wsWidths.splice(col, 1);

            orderData.forEach((orderRow, orderRowCol) => {
              orderData[orderRowCol].splice(col, 1);
            });
          }
      });
      }

      dataArray.push(headers);

      function sortFunction(a, b) {
        if (a[1] === b[1]) {
          return 0;
        }
        return (a[1] < b[1]) ? -1 : 1;
     }

      orderData.sort(sortFunction);

      const dataArrayComplete = dataArray.concat(orderData);

      const worksheet = XLSX.utils.aoa_to_sheet(dataArrayComplete, { sheet: 'Sheet JS' });

      worksheet['!cols'] = wsWidths;

      const colNames = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

      const headerStyle = { font: { bold: true } };
      const ynStyle = { alignment: { horizontal: 'center' } };

      worksheet.A1.s = headerStyle;
      worksheet.A2.s = headerStyle;
      worksheet.A3.s = headerStyle;
      worksheet.A4.s = headerStyle;
      if (!isTPN) {
        worksheet.A5.s = headerStyle;
      }
      let colLetter = '';
      let rowNumber = '';
      let cellid = '';
      dataArrayComplete.forEach((dataRow, rowNum) => {
        dataRow.forEach((dataField, colNum) => {
          colLetter = colNames[colNum];
          rowNumber = rowNum + 1;
          cellid = colLetter + rowNumber;

          if (dataRow[0] === headers[0]) {
            // this is the header row
            worksheet[cellid].s = headerStyle;
          }

          if ((dataField === 'YES') || (dataField === 'NO')) {
            worksheet[cellid].s = ynStyle;
          }
        });
      });

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');

      const today = new Date();

      const dateString = moment(today).format('YYYY-MM-DD');

      // export Excel file
      XLSX.writeFile(wb, 'BOLT_Export_' + dateString + '.xlsx'); // name of the file is 'book.xlsx'

// const dataType = 'application/msexcel';
      // const tableHTML = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"> <head> <meta http-equiv=Content-Type content="text/html; charset=windows-1252"> <meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"> <!--[if gte mso 9]><xml> <x:excelworkbook> <x:excelworksheets> <x:excelworksheet> <x:name>** WORKSHEET NAME **</x:name> <x:worksheetoptions> <x:selected></x:selected> <x:freezepanes></x:freezepanes> <x:frozennosplit></x:frozennosplit> <x:splithorizontal>** FROZEN ROWS + 1 **</x:splithorizontal> <x:toprowbottompane>** FROZEN ROWS + 1 **</x:toprowbottompane> <x:splitvertical>** FROZEN COLUMNS + 1 **</x:splitvertical> <x:leftcolumnrightpane>** FROZEN COLUMNS + 1**</x:leftcolumnrightpane> <x:activepane>0</x:activepane> <x:panes> <x:pane> <x:number>3</x:number> </x:pane> <x:pane> <x:number>1</x:number> </x:pane> <x:pane> <x:number>2</x:number> </x:pane> <x:pane> <x:number>0</x:number> </x:pane> </x:panes> <x:protectcontents>False</x:protectcontents> <x:protectobjects>False</x:protectobjects> <x:protectscenarios>False</x:protectscenarios> </x:worksheetoptions> </x:excelworksheet> </x:excelworksheets> <x:protectstructure>False</x:protectstructure> <x:protectwindows>False</x:protectwindows> </x:excelworkbook> </xml><![endif]--> </head> <body> <tableid="tblData"><tr><th>Name</th><th>Email</th><th>Country</th></tr><tr><td>JohnDoe</td><td>john@gmail.com</td><td>USA</td></tr><tr><td>MichaelAddison</td><td>michael@gmail.com</td><td>UK</td></tr><tr><td>SamFarmer</td><td>sam@gmail.com</td><td>France</td></tr></table></body> </html>';
      //
      // // Specify file name
      // const filename = 'excel_data.xls';
      //
      // const anchor = document.createElement('a');
      // anchor.href = 'data:' + dataType + ';charset=utf-8,' + encodeURIComponent(tableHTML);
      // anchor.target = '_blank';
      // anchor.download = filename;
      // anchor.click();
    },
  },
};
</script>
